<template>
  <div style="max-width: 300px;">
    <Row slot="content">
      <Col span="10">
      <InputNumber v-model="min" style="width:100%;" @on-focus="handleActiveButton"></InputNumber>
      </Col>
      <Col span="2" style="text-align: center">-</Col>
      <Col span="10">
      <InputNumber v-model="max" style="width:100%;" @on-focus="handleActiveButton"></InputNumber>
      </Col>
      <Col span="2">
        <Button style="margin-left: 10px;" v-show="displayButton" type="primary" @click="handleChange">确定</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      min: null,
      max: null,
      displayButtonFlag: false
    }
  },
  watch: {
    min() {
      //this.displayButtonFlag = true
    },
    max() {
      //this.displayButtonFlag = true
    },
    value(v) {
      if (v === null) {
        this.min = null
        this.max = null
      }
    }
  },
  computed: {
    displayButton() {
      return this.displayButtonFlag && (this.min !== null && this.max !== null && this.min !== '' && this.max !== '')
    }
  },
  props: {
    field: {
      type: String
    },
    value: {
      default: function() {
        return []
      }
    }
  },
  methods: {
    handleChange(v) {
      this.displayButtonFlag = false
      this.$emit('change', this.field, [this.min, this.max], this.min + '-' + this.max)
    },
    handleActiveButton(){
      this.displayButtonFlag = true
    }
  }
}

</script>
